import ResourceService from "./resource.service";

class PermissionsService extends ResourceService {
  static get resource() {
    return "admin/permissions";
  }
}

export default PermissionsService;
